<script setup>
import { computed } from 'vue'


const props = defineProps({ status: Number })

const title = computed(() => {
    return {
        503: { code: '503', text: 'Service temporairement indisponible' },
        500: { code: '500', text: 'Erreur serveur' },
        404: { code: '404', text: 'Page non trouvée' },
        403: { code: '403', text: 'Accès interdit' },
    }[props.status]
})

const description = computed(() => {
    return {
        503: 'Désolé, nous effectuons des opérations de maintenance. Veuillez revenir plus tard.',
        500: 'Oups, quelque chose s\'est mal passé sur nos serveurs.',
        404: 'Désolé, la page que vous cherchez est introuvable.',
        403: 'Désolé, vous n\'avez pas l\'autorisation d\'accéder à cette page.',
    }[props.status]
})

const redirectBack = () => {
    history.back()
}
</script>

<template>
    <div class="h-full w-full">
        <main class="relative isolate h-screen">
            <img src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3050&q=80&exp=8&con=-15&sat=-75"
                alt="" class="absolute inset-0 -z-10 h-full w-full object-cover object-center">
            <div class="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
                <p class="text-6xl font-semibold leading-8 text-white">{{ title.code }}</p>
                <h1 class="mt-4 text-3xl font-bold tracking-tight text-white sm:text-5xl">{{ title.text }}</h1>
                <p class="mt-4 text-base text-white/70 sm:mt-6">{{ description }}</p>
                <div class="mt-10 flex justify-center">
                    <div class="text-sm font-semibold leading-7 text-white border px-2 rounded cursor-pointer" @click="redirectBack()"><span aria-hidden="true">&larr;</span>
                        Revenir en arrière</div>
                </div>
            </div>
        </main>
    </div>

    <!-- <div class="flex items-center justify-center h-screen bg-gray-100">
        <div class="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md">
            <h1 class="text-3xl font-bold text-gray-900">Erreur {{ title }}</h1>
            <h2 class="text-xl font-medium text-gray-900">{{ description }}</h2>
            <button class="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
                @click="redirectBack()">Retour à la page d'accueil</button>
        </div>
    </div> -->
</template>